import { Modal, Row, Col } from "react-bootstrap";
import { imgPath } from "../../utils/imagePath";
import PropTypes from "prop-types";

const Details = (props) => {
  const { userdata } = props;

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Row className="mentor_detail align-items-center">
          <Col md={4}>
            <div className="mentor_pic">
              {userdata.image && <img src={userdata.image} alt="mentor" />}
              {!userdata.image && (
                <img src="assets/images/mentor_women_two.jpg" alt="mentor" />
              )}
              <div className="mentor_name">
                <h3>{userdata.first_name}</h3>
                <h5>
                  <span>{userdata.position}</span>
                  {userdata.organization === "undefined"
                    ? "N/A"
                    : userdata.organization}
                </h5>
              </div>
            </div>
          </Col>
          <Col md={8}>
            <h2>About me</h2>
            <p>{userdata.about}</p>
            <div className="profile_btn">
              <span className="link_btn">
                <img
                  src={
                    imgPath + "linkedin.png"
                  }
                  className="me-2 bg-white"
                  alt="linkedin"
                />{" "}
                Linkedin Profile
              </span>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    first_name: PropTypes.string,
    image: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
    about: PropTypes.string,
    linkedin: PropTypes.string,
  }).isRequired,
};

export default Details;
